import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Mail, Phone, MapPin, Send, CheckCircle } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    inquiry: 'general',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        company: '',
        phone: '',
        inquiry: 'general',
        message: ''
      });
    }, 3000);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="contact-page">
      {/* Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Get in Touch</h1>
          <p className="page-subtitle">
            Ready to deploy renewable infrastructure? Our team is here to help.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <Card className="contact-form-card">
              <h2 className="form-title">Send us a Message</h2>
              
              {submitted ? (
                <div className="form-success">
                  <CheckCircle size={48} className="success-icon" />
                  <h3>Message Sent!</h3>
                  <p>Thank you for contacting us. We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <Label htmlFor="name">Full Name *</Label>
                      <Input
                        id="name"
                        type="text"
                        placeholder="John Smith"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <Label htmlFor="email">Email Address *</Label>
                      <Input
                        id="email"
                        type="email"
                        placeholder="john@company.com"
                        value={formData.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <Label htmlFor="company">Company</Label>
                      <Input
                        id="company"
                        type="text"
                        placeholder="Your Company"
                        value={formData.company}
                        onChange={(e) => handleChange('company', e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <Label htmlFor="phone">Phone Number</Label>
                      <Input
                        id="phone"
                        type="tel"
                        placeholder="+44 7576 884014"
                        value={formData.phone}
                        onChange={(e) => handleChange('phone', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <Label htmlFor="inquiry">Inquiry Type</Label>
                    <Select value={formData.inquiry} onValueChange={(value) => handleChange('inquiry', value)}>
                      <SelectTrigger id="inquiry">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="general">General Inquiry</SelectItem>
                        <SelectItem value="sales">Sales & Deployment</SelectItem>
                        <SelectItem value="technical">Technical Support</SelectItem>
                        <SelectItem value="investor">Investor Relations</SelectItem>
                        <SelectItem value="partnership">Partnership Opportunity</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="form-group">
                    <Label htmlFor="message">Message *</Label>
                    <Textarea
                      id="message"
                      placeholder="Tell us about your project or inquiry..."
                      rows={6}
                      value={formData.message}
                      onChange={(e) => handleChange('message', e.target.value)}
                      required
                    />
                  </div>

                  <Button type="submit" size="lg" className="submit-button">
                    <Send className="mr-2" />
                    Send Message
                  </Button>
                </form>
              )}
            </Card>

            {/* Contact Info */}
            <div className="contact-info-section">
              <Card className="contact-info-card">
                <h3 className="info-title">Contact Information</h3>
                <div className="info-items">
                  <div className="info-item">
                    <div className="info-icon">
                      <MapPin />
                    </div>
                    <div className="info-content">
                      <h4>Office Address</h4>
                      <p>308 North Road<br />Yate, Bristol<br />BS37 7LL<br />United Kingdom</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <Phone />
                    </div>
                    <div className="info-content">
                      <h4>Phone</h4>
                      <p>+44 7576 884014</p>
                      <span className="info-note">Mon-Fri, 9:00 AM - 6:00 PM GMT</span>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <Mail />
                    </div>
                    <div className="info-content">
                      <h4>Email</h4>
                      <p>chris.turner.cycom@gmail.com</p>
                      <span className="info-note">We respond within 24 hours</span>
                    </div>
                  </div>
                </div>
              </Card>

              <Card className="quick-links-card">
                <h3 className="info-title">Quick Links</h3>
                <ul className="quick-links">
                  <li><a href="/calculator">Calculate Your ROI</a></li>
                  <li><a href="/technology">View Technology</a></li>
                  <li><a href="/platform">Live Platform Demo</a></li>
                  <li><a href="/investors">Investor Information</a></li>
                </ul>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
